import { useContext, useState } from "react";
import Logo from "../../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM.jpeg";
import { loginValidation } from "../../schemas/loginValidation";
import { validateField, validateForm } from "../../schemas/loginValidation";
import { DContext } from "../../context/Datacontext";
import { LoginService } from "../../services/auth/AuthService";
import { useLocation, useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa";
import { GoogleOAuth } from "./GoogleOAuth";
import Loading from "../../components/Loading";

export const Login = () => {
    const { BeURL, Mandatory ,loading,setLoading }=useContext(DContext)
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate()

    const location = useLocation()
    const state = location.state || {};

    const [form, setForm] = useState({
        email: "",
        password: "",
        remember: false,
    });

    const [errors, setErrors] = useState({});

    //LIVE VALIDATION HERE
    const handleChange = (name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));

        const error = validateField(
            name,
            value,
            { ...form, [name]: value },
            loginValidation
        );

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationErrors = validateForm(form, loginValidation);
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            if (BeURL) {
                setLoading(true)
                LoginService({
                    email: form.email,
                    password: form.password,
                    BeURl: BeURL,
                    state
                }).then((data) => {
                    if (data.success) {
                        if(data.user?.role === 'user'){
                            window.location.href = '/learner/courses';
                            return;
                        }
                        window.location.href = '/app/dashboard';
                    } else {
                        setLoading(false)
                        alert(data.message);
                    }
                });
            }
        }
    };

    return (
        <div className="flex items-center justify-center">
            <div className="w-full max-w-md p-8 space-y-6">
                <div className="flex flex-col items-center">
                    <img src={Logo} alt="logo" className="mb-6 h-auto w-32" />
                </div>
                <h2 className="text-2xl font-semibold mb-2">Welcome Back to SAN LMS</h2>
                <p>Log in to continue your learning journey and access your courses, progress, and training resources.</p>

                <form onSubmit={handleSubmit}>
                    {/* EMAIL */}
                    <div className="mb-4">
                        <label className="text-sm text-gray-600">
                            Email {Mandatory()}
                        </label>
                        <input
                            type="email"
                            value={form.email}
                            placeholder="example@gmail.com"
                            onChange={(e) =>
                                handleChange("email", e.target.value)
                            }
                            className={`w-full border rounded-md px-3 py-2 mt-1
              ${errors.email
                                    ? "border-red-500 focus:ring-red-400"
                                    : "focus:ring-primary-500"}
              focus:outline-none focus:ring-2`}
                        />
                        {errors.email && (
                            <p className="text-xs text-red-500 mt-1">
                                {errors.email}
                            </p>
                        )}
                    </div>

                    {/* PASSWORD */}
                    <div className="mb-2 relative">
                        <label className="text-sm text-gray-600">
                            Password {Mandatory()}
                        </label>
                        <input
                            type={showPassword ? "text" : "password"}
                            value={form.password}
                            placeholder="........"
                            onChange={(e) =>
                                handleChange("password", e.target.value)
                            }
                            className={`w-full border rounded-md px-3 py-2 mt-1 placeholder:text-4xl 
              ${errors.password
                                    ? "border-red-500 focus:ring-red-400"
                                    : "focus:ring-primary-500"}
              focus:outline-none focus:ring-2`}
                        />
                        <span
                            className="absolute right-3 text-xl  top-10 cursor-pointer text-gray-500"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? (
                                <IoEyeOutline />
                            ) : (
                                <FaRegEyeSlash />
                            )}
                        </span>

                        {errors.password && (
                            <p className="text-xs text-red-500 mt-1">
                                {errors.password}
                            </p>
                        )}
                    </div>

                    <div onClick={() => navigate('/forgotpassword')} className="underline text-right text-sm text-primary-600 hover:text-primary-700 mb-4 cursor-pointer"> Forgot password? </div> {/* Keep logged */} 
     
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-primary-600 hover:bg-primary-700 text-white py-3 rounded-md mt-6 flex justify-center"
                    >
                        {loading ? <Loading size={30} className="text-white" /> : "Log In"}
                    </button>
                </form>
                <p className="text-sm text-gray-500 mb-6"> Don't have an account?{" "} <span className="text-primary-600 cursor-pointer font-medium" onClick={() => navigate('/register')}> Sign up </span> </p>

                <div className="w-full flex items-center justify-center mb-4">
                    <GoogleOAuth BeURL={BeURL} />
                </div>
            </div>
        </div>
    );
};



